import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import BackButton from "../../image/BackButton.svg";
import Setting from "../../image/Setting.svg";
import Alert from "../../image/Alert.svg";
import DownToggle from "../../image/DownToggle.svg";
import DownUpToggle from "../../image/DownUpToggle.svg";
import History from './History/History';
import "./Forms.css";
import Popup from 'reactjs-popup';
import { Button, DialogContent, DialogContentText, FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import MailIcon from '../../Components/MainIcons/MailIcon';

 const Form = (props) => {

  const location = useLocation();
  const currentUrl = location.pathname;

const[bigArray,setbigArray]=useState({})
  const [datamines,Setdatamines]=useState({});

const[title,settite]=useState("empty")
  const[desc,setdesc]=useState("empty")
  const[seconddesc,setseconddesc]=useState("empty")
  
 const [isReadMore, setIsReadMore] = useState(true);
 const toggleReadMore = () => {setIsReadMore(!isReadMore)};

 const [isReadmore, setIsReadmore] = useState(true);
 const toggleReadmore = () => {setIsReadmore(!isReadmore)};
  const params = useParams();
  const Navigate = useNavigate();

  // For Dropdown
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };

 useEffect(()=>
 {


  const myfunc=async ()=>
  {
  
      const response = await fetch(`http://localhost:3001/form/${params._id}`, {
              method: 'GET', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              // credentials: 'same-origin', // include, *same-origin, omit
              headers: {
              //   'Content-Type': 'application/json',
            
                "x-jwt-token":process.env.REACT_APP_X_JWT_TOKEN
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              // body: JSON.stringify(data) // body data type must match "Content-Type" header
            }).then((data)=>
            {
              data.json().then((data)=>
              {
                
                  setbigArray(data);
                  Setdatamines(data);
                  settite(data.title);
            setdesc(data.components[0].defaultValue);
            setseconddesc(data.components[1].defaultValue);
       
                 
                  
              })
            }).catch((err)=>
            {
              console.log(err);
            })
          }

          myfunc();




 },[])
  


 function logout() {
  // props.history.push('/');

  props.state.keycloak.logout();

  
}


     return (<>
     <div className='SecondPage'>
      <div className="EvidenceTaskNavbar" style={{marginRight:"2rem"}}>
        <div>
        <span className='ArrowIcon'>
        {currentUrl.split("/")[1]=="forms"?  <button className='Backbutton'>
          
          
          <Link to="/forms">
            <img src={BackButton} alt="BackIcon" className='BackbuttonIcon'/>
          </Link>
        </button>:  <button className='Backbutton'>
          
          
          <Link to="/applications">
            <img src={BackButton} alt="BackIcon" className='BackbuttonIcon'/>
          </Link>
        </button>}
          
         </span>
       
          <span className="EvidenceTitle">{datamines.title}</span>
        </div>
        <div>
        <MailIcon state={props.state} />
        </div>
      </div>

      <div className='DownBlock'>
        <div className='SecondpageDiscription'>
          
            <>
            
            <span className='Definition'>Metrics Definition</span>
            {/* <p className='Paragraph'> {desc} </p> */}
            
            
            </>
           
            {/* <p className='Paragraph'>{isReadMore ? desc.slice(0,30): desc } {desc.length > 30 && desc.length > ""&&
            <span onClick={toggleReadMore} className="ReadMoreToggle">
              {isReadMore ? "...Read more" : "...Read less"}
            </span>} 
            </p> */}
            <>

            <span className='Definition'>Metrics Rationale</span>
            {/* <p className='Paragraph'> {seconddesc} </p> */}
            {/* <p className='Paragraph'>{isReadmore ? seconddesc.slice(0,30): seconddesc }
            {seconddesc.length >30 && desc.length > ""&&
            <span onClick={toggleReadmore} className="ReadMoreToggle">
              {isReadmore ? "...Read more" :"...Read less"}
            </span>}
              </p> */}
            

          </>
        </div>
    

        <History bigArray={bigArray}/>
        </div>
      </div>  
    </>
  )
}


export default Form;
